import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIcon } from '@angular/material/icon';


import { I18nModule, provideConfig } from '@spartacus/core';
import { MediaModule } from '@spartacus/storefront';

import { DpSearchBoxComponent } from './search-box.component';
import { DpSearchedProductComponent } from '@app/ui-components/searched-product';
import { DpStockInfoComponent } from '@app/ui-components/stock-info';

@NgModule({
  imports: [CommonModule, I18nModule, MatIcon, DpStockInfoComponent, MediaModule, DpSearchedProductComponent],
  providers: [
    provideConfig({
      cmsComponents: {
        SearchBoxComponent: {
          component: DpSearchBoxComponent
        }
      }
    })
  ],
  declarations: [DpSearchBoxComponent],
  exports: [DpSearchBoxComponent]
})
export class DpSearchBoxModule {}
